import z from "zod";
import { PublicDocumentSchema } from "../../models/document.schema";

export const DocumentControllerResponseSchema = {
  listPublicDocuments: PublicDocumentSchema.array(),

  getPublicDocument: PublicDocumentSchema.nullable(),

  downloadPublicDocument: z.void().nullable(),

  downloadPublicAttachment: z.void().nullable(),
};
